import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import AMP_KEYS from '@/configs/amp-track-keys';
import useWorkspaceStore from '@/stores/WorkspaceStore';
import { track } from '@/utils/track/track';

export type ModalDomain =
  | 'feedbacks'
  | 'feedback-blocks'
  | 'topics'
  | 'agents'
  | 'customers'
  | 'companies'
  | 'agent-view'
  | 'agent-issue-mention'
  | 'agent-feedback'
  | 'global-search'
  | 'view-coverage'
  | 'trending'
  | 'hey-syncly'
  | 'category-mention';

type Props<T> = {
  domain: ModalDomain;
  alias?: string;
  options?: T;
};

const useTrackModal = <T extends {}>(props: Props<T>) => {
  const location = useLocation();
  const currWorkspace = useWorkspaceStore((state) => state.currWorkspace);
  const workspace_id = currWorkspace?.alias;

  useEffect(() => {
    if (!workspace_id) return;
    track(AMP_KEYS.PAGE_VIEW, {
      pathname: `/workspace/${workspace_id}/${props.domain}/${
        props.alias || ''
      }`,
      query: location.search,
      isModal: true,
      ...props.options,
    });
  }, [
    props.alias,
    props.domain,
    location.pathname,
    location.search,
    workspace_id,
    props.options,
  ]);
};

export default useTrackModal;
